// extracted by mini-css-extract-plugin
module.exports = {"input":"a10a3f92e9--input--bZIJ1"};